module.exports = __webpack_public_path__ + "static/img/twjd-sdo1.a944d1e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo1.png
// module id = 852
// module chunks = 0